const numbers = {
  distantFuture: 2147483647,
  distantPast: 0,
};

export default numbers;

export const TAG_TYPE_ORG_STRUCTURE = 'orgStructure';
export const TAG_TYPE_ORG_STRUCTURE_REQUEST = 'orgStructureRequest';
export const TAG_TYPE_CAPABILITY = 'capability';

export const DEFAULT_START_TIME = '09:00';
export const DEFAULT_END_TIME = '17:00';



// WEBPACK FOOTER //
// ./src/constants.js